var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobile = function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 339 732",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.407 688.21C338.407 712.055 318.915 731.563 295.09 731.563H43.3175C19.4922 731.563 0 712.055 0 688.21V43.3534C0 19.5084 19.4922 0 43.3175 0H295.09C318.915 0 338.407 19.5084 338.407 43.3534V688.21Z",
    fill: "#EAEAEA"
  })));
};
export default SvgMobile;